<template>
  <div
    class="bto-sb-history-footer"
    v-if="
      showRebet ||
      showPaidBtn ||
      showCancelPlacedBtn ||
      showOnDemandCashout ||
      canPrintBetSlipFromHistory
    ">
    <template v-if="showCashout">
      <a
        v-if="cashoutCircularLoader"
        :class="[
          'bto-sb-form-btn bto-sb-btn-cashout',
          { 'bto-sb-loader': cashoutCircularLoader === true },
        ]">
        <i class="bto-sb-spinner-v1"></i>{{ t("Mobile.CashingOut") }}
      </a>
      <span v-else-if="cashoutCircularLoader === false && cashoutNewOffer === 0 && (cashoutStep === 3 || cashoutStep === 2)"
        class="bto-sb-form-btn bto-sb-btn-suspended">
        {{t('M.CashoutSuspended')}}
      </span>
      <a
        v-else-if="cashoutCircularLoader === false && cashoutVal > 0"
        :class="[
          'bto-sb-form-btn bto-sb-btn-cashout',
          {
            'bto-sb-btn-cashoutconfirm':
              cashoutCircularLoader === false && (cashoutStep === 1 || cashoutStep === 2),
          },
        ]"
        @click.stop="processCashout(cashoutVal)">
        <span :class="{ 'bto-app-icon bto-app-check': cashoutStep === 4 }"></span>
        {{ cashoutBtnName }} {{ cashoutVal | formatAmountDisplay }}
      </a>
      <a
        v-if="cashoutCircularLoader === false && (cashoutStep === 1 || cashoutStep === 2)"
        class="bto-sb-form-btn bto-sb-form-btn-delete"
        @click.stop="cancelCashout()">
        <i class="bto-app-delete"></i>
      </a>
    </template>

    <rebet-button
      class="bto-sb-form-btn bto-sb-btn-rebet"
      v-if="showRebet"
      :betDetails="betDetails"
      :tag="'a'" />
    <a
      class="bto-sb-form-btn bto-sb-btn-print"
      v-if="canPrintBetSlipFromHistory"
      @click.stop="printTicket($event)">
      {{ t("Public.Print") }}
    </a>
  </div>
</template>

<script>
  import base from './base';
  import RebetButton from '../mybet-details-footer/buttons/rebet-button';

  export default {
    name: 'MyBetsInlineFooter',
    extends: base,
    components: {
      RebetButton,
    },
  };
</script>